<template>
    <section class="chart code examples">
      <h3>Line chart examples</h3>
      <LineChartExampleBasic/>
      <LineChartExampleUpdate/>
      <LineChartExampleCustomization/>
    </section>
</template>


<script>
export default {
  name: 'LineChartExamples',
}
</script>